export default __webpack_public_path__ + "static/stickers-cuadrados-kit-89df0ee267927e76044ee38886991a8a.jpg";